const {resolveUrl} = require('./scriptUrlResolver')

module.exports = {
    resolveUrl
}
